<template>
  <div class="select_country">
    <div class="head" v-if="true">
      <h2>选择国家/地区</h2>
      <span class="el-icon-arrow-left" @click="goBack"></span>
    </div>
    <div class="search">
      <img src="../assets/img/verify/search1.png" alt />
      <input type="text" placeholder="搜索国家/地区" v-model="country" />
      <div class="clear" v-show="showClear" @click="handleClear">
        <img src="../assets/img/verify/quxiao1.png" alt />
      </div>
    </div>
    <div class="country">
      <div class="country_chinese">
        <ul>
          <li
            v-for="item in cn_list"
            :key="item.id"
            @click="handleAreaCode(item.code)"
          >
            <span>{{ item.name }}</span>
            <span>+{{ item.code }}</span>
          </li>
        </ul>
      </div>
      <div class="country_foreign">
        <ul>
          <li
            v-for="item in ncn_list"
            :key="item.id"
            @click="handleAreaCode(item.code)"
          >
            <span>{{ item.name }}</span>
            <span>+{{ item.code }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom">WOW·已经到底了</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cn_list: [], //中国地区
      ncn_list: [], //外国地区
      country: "",
      showClear: false,
    };
  },

  mounted() {
    this.$API.getAreaCode().then((res) => {
      // console.log(res);
      this.cn_list = res.data.cn_list;
      this.ncn_list = res.data.ncn_list;
      localStorage.setItem("cn_list", JSON.stringify(this.cn_list));
      localStorage.setItem("ncn_list", JSON.stringify(this.ncn_list));
    });
  },
  watch: {
    country() {
      this.country.trim() == ""
        ? (this.showClear = false)
        : (this.showClear = true);

      this.cn_list = JSON.parse(localStorage.getItem("cn_list"));
      this.ncn_list = JSON.parse(localStorage.getItem("ncn_list"));
      if (this.country != "") {
        this.cn_list = this.cn_list.filter((v) => {
          return v.name.includes(this.country);
        });
        this.ncn_list = this.ncn_list.filter((v) => {
          return v.name.includes(this.country);
        });
      } else {
        this.cn_list = JSON.parse(localStorage.getItem("cn_list"));
        this.ncn_list = JSON.parse(localStorage.getItem("ncn_list"));
      }
    },
  },
  methods: {
    handleAreaCode(code) {
      this.$emit("selectAreaCode", code);
    },
    goBack() {
      this.$emit("selectAreaCode");
    },
    handleClear() {
      this.country = "";
      this.cn_list = JSON.parse(localStorage.getItem("cn_list"));
      this.ncn_list = JSON.parse(localStorage.getItem("ncn_list"));
    },
  },
};
</script>

<style scoped lang="scss">
.select_country {
  font-family: "PingFang SC";
  height: 100%;
  padding-bottom: 20px;
  .head {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    position: relative;
    h2 {
      font-size: 17px;
      font-weight: 500;
      color: #323643;
      letter-spacing: 0px;
    }
    span {
      position: absolute;
      top: 9px;
      left: 17px;
      font-size: 22px;
      font-weight: 550;
    }
  }
  .search {
    width: 343px;
    height: 30px;
    margin: 16px auto 16px;
    position: relative;

    input {
      padding-left: 34px;
      width: 309px;
      height: 30px;
      font-size: 14px;
      caret-color: #07d1aa;
      background: #efefef;
      border-radius: 15px;
      border: none;
      outline: none;
    }
    img {
      width: 14px;
      height: 14px;
      position: absolute;
      top: 8px;
      left: 14px;
    }
    .clear {
      position: absolute;
      top: -1px;
      right: 36px;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
  .country {
    font-size: 12px;
    font-weight: 500;
    color: #585b63;
    margin-bottom: 78px;
    .country_chinese {
      border-bottom: 10px solid #f8f8f8;
      ul {
        li {
          margin-top: 10px;
          padding: 0 16px;
          height: 34px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #d9d9d9;
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
    .country_foreign {
      margin-top: 16px;
      ul {
        li {
          margin-top: 10px;
          padding: 0 16px;
          height: 34px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #d9d9d9;
        }
      }
    }
  }
  .bottom {
    font-size: 14px;
    color: #abacb1;
  }
}

//修改placeholder的默认颜色：
input::-webkit-input-placeholder {
  color: #c1c2c6;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c1c2c6;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c1c2c6;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #c1c2c6;
}
img {
  object-fit: cover;
}
</style>